import type { TransportCatalogSearchCriteria } from '../../store/state/monitoring/transport/models/transport.model';
import type { TransportManagementSearchCriteria } from '../../store/state/monitoring/transport-management/models/transport-management.model';
import type { AutomotiveAftermarketSearchCriteria } from '../../store/state/monitoring/automotive-aftermarket/models';
import type { AllocationViewListSearchCriteria } from '../../store';

export type CatalogSearchCriteria =
  | TransportCatalogSearchCriteria
  | TransportManagementSearchCriteria
  | AutomotiveAftermarketSearchCriteria
  | AllocationViewListSearchCriteria;
